import { Injectable } from '@angular/core';
import { AppService } from '../App/app.service';
import { GLanguageProvider } from './g-language.provider';
import { GeneralExerciseComponent } from './g-exercise.component';
import { GeneralTeacherComponent } from './gt.component';

@Injectable()
export class GTopicService {

  protected configuration: any = null;
  protected state: any = null;
  protected language: any = null;
  protected languageAbbrev: string = null;
  public type;


  constructor(protected languageProvider: GLanguageProvider, protected appService: AppService) {
    this.appService.registerLanguageChangeCallback(this.changeLanguage.bind(this));
    this.changeLanguage(this.appService.languageAbbreviation);
  }

  /** get text in right language
* @param {string} tag - text to loadF
*/
  get(tag: string): string {
    let result: string = this.language[tag];
    if (result === undefined || result === '' || result == null) {
      result = this.appService.get(tag);
    }
    return result;
  }

  /** returns title of topic */
  getTitle(): string {
    return this.configuration['title'];
  }

  /** returns id of topic */
  getId(): number {
    return this.configuration['id'];
  }

  /** returns type of topic */
  getType(): string {
    return this.configuration['type'];
  }

  /** returns title of topic */
  getImage(): string {
    return this.configuration['image'];
  }

  /** returns all exercises  */
  getAllExercises(): any[] {
    this.configuration = this.appService.getTopicConfiguration(this.type);
    return this.configuration['exercises'];
  }

  /** returns for all exercises the id, the title, the type and the image and the state(solved)*/
  getAllExercisesInfo(): any[] {
    this.configuration = this.appService.getTopicConfiguration(this.type);
    const allExercises: any[] = this.configuration['exercises'];
    const result: any[] = [];
    let temp: any = {};
    for (const exercise of allExercises) {
      temp.id = exercise['id'];
      temp.image = exercise['image'];
      temp.title = exercise['title'];
      temp.type = exercise['type'];
      temp.key = exercise['key'];
      temp.level = exercise['level'];
      temp.player = exercise['player'];
      temp.helperVideo = exercise['helperVideo'];
      const state = this.getStateByKey(temp.key);
      temp.solved = false;
      if (state !== undefined) {
        if (state.solved !== undefined) {
          temp.solved = state.solved;
        }
      }
      result.push(temp);
      temp = {};
    }
    return result;
  }

  /** returns the titles of all exercises for this topic */
  getAllExerciseTitles(): string[] {
    const allExercises: any[] = this.configuration['exercises'];
    const result: string[] = [];
    for (const exercise of allExercises) {
      result.push(exercise['title']);
    }
    return result;
  }

  /** returns the Configuration for a specific exercise
   * @param {number} id - the id of the requested exercise
   */
  getExerciseById(id: number): any {
    const allExercises: any[] = this.configuration['exercises'];
    for (const exercise of allExercises) {
      if (exercise['id'] === id) {
        return exercise;
      }
    }
    return {};
  }

  /** returns the state of the exercise with the given key
   * @param key: exerciseKey
  */
  getStateByKey(key: string): any {
    const allExercises: any[] = this.state['exercises'];
    for (const exercise of allExercises) {
      if (exercise['key'] === key) {
        return exercise;
      }
    }
    const state = { typespecific: {} };
    return state;
  }

  /** returns the maximal id found in the all exercise for this topic */
  getMaxId(): number {
    const allExercises = this.getAllExercises();
    let maxId = 0;

    for (const exercise of allExercises) {
      if (exercise.id > maxId) {
        maxId = exercise.id;
      }
    }
    return maxId;
  }

  /** returns position in array of exercise with id withing the configuration
   * @param {number} id - id of requested exercise
  */
  getPositionByIdConfiguration(id: number, allItems: any): number {
    let index = 0;
    for (const item of allItems) {
      if (item.id === id) {
        return index;
      }
      index++;
    }
    return -1;
  }

  /** returns position in array of exercise with id withing the configuration
   * @param {number} key - id of requested exercise
  */
  getPositionByKeyState(key: string): number {
    const allExercises = this.state['exercises'];
    let index = 0;
    for (const exercise of allExercises) {
      if (exercise['key'] === key) {
        return index;
      }
      index++;
    }
    return -1;
  }

  /** requests the appService to add this to the configuration
   * @param {any} definition - holds the specification of the exercise
  */
  addExercise(definition: any) {
    this.configuration.exercises.push(definition);
    this.appService.updateConfiguration(this.type, this.configuration);
  }

  /** requests the appService to update this exercise
     * @param {any} definition - holds the specification of the exercise
    */
  updateExercise(definition: any) {
    this.configuration.exercises[this.getPositionByIdConfiguration(definition.id, this.getAllExercisesInfo())] = definition;
    this.appService.updateConfiguration(this.type, this.configuration);
  }

  /** requests the appService to update all the exercises
   * @param {any} definition - new exercises
  */
  updateAllExercises(definition: any) {
    this.configuration.exercises = definition;
    this.appService.updateConfiguration(this.type, this.configuration);
  }

  /** sets the state
   * @param {string} key - key of exercise to set
   * @param {any} state - state to set
  */
  setStateByKey(key: string, state: any) {
    state.key = key;
    const position = this.getPositionByKeyState(key);
    if (position < 0) {
      this.state.exercises.push(state);
      console.log(state);
    } else {
      this.state.exercises[position] = state;
    }
    this.appService.setState(this.type, this.state);
  }

  /** resets the satet of the given key
   * @param {string} key: key of state to reset
   */
  resetStateByKey(key: string) {
    const position = this.getPositionByKeyState(key);
    if (position < 0) {
      return;
    } else {
      this.state.exercises.splice(position, 1);
    }
    this.appService.setState(this.type, this.state);
  }

  /** registers the current exercise */
  registerExerise(exercise: GeneralExerciseComponent) {
    this.appService.currentExercise = exercise;
  }

  /** registers the current exercise */
  registerTeacherExerise(exercise: GeneralTeacherComponent) {
    this.appService.currentTeacherExercise = exercise;
  }

  /** redirects to next exercise */
  nextClicked(): any {
    const id = this.appService.currentExercise.getID();
    const allExercises = this.getAllExercisesInfo();
    let index = 0;
    let found = false;
    for (const exercise of allExercises) {
      if (found) {
        return { path: exercise.type, id: exercise.id };
      }
      if (exercise.id === id) {
        found = true;
      }
      index++;
    }
    return { path: '', id: undefined };
  }

  /** challback function on language change, registered at the appService*/
  changeLanguage(language: string) {
    this.languageProvider.loadLanguage(language).then(language => this.language = this.languageProvider.getLanguage());
  }

  /** return the language defined in applicationService */
  getLanguage(): string {
    return this.appService.languageAbbreviation;
  }


  /** Determines the visibility of a given tip */
  showTip(name: string): boolean {
    return this.appService.showTip(name);
  }

  /** closes the given tip permanently */
  closeTip(name: string) {
    this.appService.closeTip(name);
  }

  /** tell whether or not the teachers place is visible */
  isTeachersPlaceVisible(): boolean {
    return this.appService.isTeachersPlaceVisible();
  }

}
